export default {
  HELP_CHAT: "helpchat"
};
